// @ts-ignore
import { STB, API_URL, NIMBLY_API } from '@env';

const ENV_NIMBLY_STORAGE_BUCKET = 'gs://nimbly-bucket-asia-southeast2';

// ISSUE TRACKER
const NIMBLY_API_ISSUE_BASE = `${API_URL}/issues`;
const NIMBLY_API_ISSUES = `${NIMBLY_API_ISSUE_BASE}/issues`;
const NIMBLY_API_ISSUES_MESSAGE = `${NIMBLY_API_ISSUE_BASE}/issueMessages`;

export const NIMBLY_API_ISSUES_DETAIL = `${NIMBLY_API_ISSUES}/`;
export const NIMBLY_API_ISSUES_LIST = `${NIMBLY_API_ISSUES}/`;
export const NIMBLY_API_ISSUES_CREATE = `${NIMBLY_API_ISSUES}/create`;
export const NIMBLY_API_ISSUES_COMMENT = `${NIMBLY_API_ISSUES_MESSAGE}/create`;
export const NIMBLY_API_ISSUES_UPLOAD_PHOTO = `${NIMBLY_API_ISSUES_MESSAGE}/upload`;
export const NIMBLY_API_ISSUES_UPDATE = `${NIMBLY_API_ISSUES}/update`;
export const NIMBLY_API_ISSUES_READ_STATUS = `${NIMBLY_API_ISSUES}/readStatus`;
export const NIMBLY_API_ISSUES_READ_ALL_STATUS = `${NIMBLY_API_ISSUES}/readAll`;

// QUESTIONNAIRES
const NIMBLY_API_QUESTIONNAIRES_BASE = `${API_URL}/questionnaires`;
export const NIMBLY_API_QUESTIONNAIRES = `${NIMBLY_API_QUESTIONNAIRES_BASE}`;
export const NIMBLY_API_QUESTIONNAIRES_INDEX = `${NIMBLY_API_QUESTIONNAIRES_BASE}/questionnaireIndexes`;

// USER ACTIVITIES
const NIMBLY_API_ACTIVITIES_BASE = `${API_URL}/activities`;
export const NIMBLY_API_CREATE_ACTIVITY = `${NIMBLY_API_ACTIVITIES_BASE}/`;

// PROMOTIONS
const NIMBLY_API_PROMOTION_BASE = `${API_URL}/promotions`;
export const NIMBLY_API_PROMOTION_ALL = `${NIMBLY_API_PROMOTION_BASE}/all`;

// NPS
const NIMBLY_API_NPS_BASE = `${API_URL}/users/userNPS`;

// Card 2151 / Phase 4: log in against the credential store rather than
// signing in to Firebase with the password directly. Unauthenticated, and
// gateway-whitelisted because it is the call that creates the session.
export const NIMBLY_API_USER_LOGIN = `${API_URL}/users/login`;

// ADR-065 Phase 3: the profile, served from Mongo by api-users.
export const NIMBLY_API_USER_PROFILE = (userID: string) => `${API_URL}/users/${userID}`;
export const NIMBLY_API_USER_LANGUAGE = `${API_URL}/users/language`;
// ADR-065 Phase 4: device identity, held in Mongo by api-users.
export const NIMBLY_API_USER_LOGGED_DEVICE = (appID: string) => `${API_URL}/users/loggedDevice/${appID}`;
// ADR-069: the push token, held in Mongo by api-users.
export const NIMBLY_API_USER_PUSH_TOKEN = `${API_URL}/users/pushToken`;
export const NIMBLY_API_NPS_IS_ELIGIBLE = `${NIMBLY_API_NPS_BASE}/eligible`;
export const NIMBLY_API_NPS_SUBMITTED = `${NIMBLY_API_NPS_BASE}/submit`;

// TARGET
export const NIMBLY_API_SALES_TARGET = `${API_URL}/sales/target/current`;

// REPORTS
export const NIMBLY_API_SITE_REPORTS = `${API_URL}/reports/new-summary/site/`;

// UPLOADS
export const NIMBLY_API_REPORT = `${API_URL}/reports/app`;
export const NIMBLY_STORAGE_BUCKET = `${ENV_NIMBLY_STORAGE_BUCKET}`;

// AUDIT-LITE v1.0 — SCHEDULES
// Note: API_URL already includes /v1.0 base path
export const NIMBLY_API_SCHEDULES_LITE_V2 = `${API_URL}/schedules/lite/v2`;
export const NIMBLY_API_SCHEDULES_LITE_ACTIVE_PERIOD = `${API_URL}/schedules/lite/active-period`;
export const NIMBLY_API_SCHEDULES_LITE_INDICATOR = `${API_URL}/schedules/lite/indicator`;
export const NIMBLY_API_CHECKIN_REPORT = `${API_URL}/schedules/lite/check-in-report`;

// AUDIT-LITE v1.0 — REPORTS
export const NIMBLY_API_REPORT_UPDATE = `${API_URL}/reports/app/lite`;
export const NIMBLY_API_REPORT_SUBMIT = `${API_URL}/reports/app/lite`;
export const NIMBLY_API_REPORT_DELETE = `${API_URL}/reports/app`;
export const NIMBLY_API_REPORT_SUMMARY = `${API_URL}/reports/lite/summary`;
export const NIMBLY_API_REPORT_SUMMARY_GROUP = `${API_URL}/reports/lite/summary/group`;

// AUDIT-LITE v1.0 — ATTACHMENTS
export const NIMBLY_API_ATTACHMENT_SIGNED_URL = `${API_URL}/miscellaneous/upload-file/report/signed-url`;

// AUDIT-LITE v1.0 — NPS
export const NIMBLY_API_NPS_TRIGGER = `${API_URL}/nps/triggerNps`;
export const NIMBLY_API_NPS_QUESTIONNAIRE = `${API_URL}/nps/npsQuestionnaire`;
export const NIMBLY_API_NPS_REPORT = `${API_URL}/nps/nps-report`;

// USERS
// Both are unauthenticated and gateway-whitelisted: they are the endpoints
// that run before there is a session. api-users owns the link they mail and
// the /users/confirm-password that redeems it, so the password set through
// either one reaches the credential store.
export const NIMBLY_API_USERS_RESET_PASSWORD = `${API_URL}/users/reset-password`;

const apiProdURL = API_URL;
const MONGO_API = NIMBLY_API;
const STORYBOOK = STB || 'false';
export { apiProdURL, MONGO_API, STORYBOOK };
